export default __webpack_public_path__ + "static/media/avatar_116.65359e6d.png";